import React from 'react';
import { SearchWrapper } from './filter-organizations.styles';
import { FilterOrganizationsProps } from './types';
import { Search } from '@shared/ui/search/search';

export const FilterOrganizations: React.FC<FilterOrganizationsProps> = ({
    organizationsListParameters,
    setOrganizationsListParameters,
}) => {
    return (
        <SearchWrapper>
            <Search
                parameters={organizationsListParameters}
                setParameters={setOrganizationsListParameters}
                placeholder='Поиск по названию или ИНН'
            />
        </SearchWrapper>
    );
};
